import { Link } from "react-router-dom";
import { api, fmtDate, gbp } from "@/admin/api";
import { Card, Empty, ErrorMsg, Loading, Stat, useAsync } from "@/admin/ui";

export default function Overview() {
  const { data, error, loading } = useAsync(() => api("/admin/overview"), []);
  if (loading) return <Loading />;
  if (error) return <ErrorMsg error={error} />;
  return (
    <div data-testid="overview-page" className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-navy md:text-3xl">Today at a glance</h1>
        <p className="mt-1 text-sm text-body">{fmtDate(data.today)}</p>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Link to="/admin/enquiries" className="block"><Stat testId="stat-new-enquiries" label="New enquiries" value={data.new_enquiries} /></Link>
        <Link to="/admin/calendar" className="block"><Stat testId="stat-today-bookings" label="Today's bookings" value={data.today_bookings.length} /></Link>
        <Link to="/admin/revenue" className="block"><Stat testId="stat-month-revenue" label="This month so far" value={gbp(data.month_revenue)} /></Link>
        <Link to="/admin/revenue" className="block"><Stat testId="stat-lifetime-revenue" label="Lifetime revenue" value={gbp(data.lifetime_revenue)} /></Link>
      </div>
      <section>
        <h2 className="mb-3 text-lg font-bold text-navy">Today's bookings</h2>
        {data.today_bookings.length === 0 ? (
          <Empty testId="today-bookings-empty">Nothing booked for today.</Empty>
        ) : (
          <ul className="space-y-3">
            {data.today_bookings.map((b) => (
              <li key={b.id}>
                <Link to={`/admin/jobs/${b.job_id}`} data-testid={`today-booking-${b.id}`} className="block">
                  <Card className="flex items-center justify-between gap-4 hover:border-brand">
                    <div>
                      <p className="font-semibold text-navy">{b.time ? `${b.time} · ` : ""}{b.name}</p>
                      <p className="text-sm text-body">{b.kind === "site_visit" ? "Site visit" : "Job"}{b.work_type ? ` · ${b.work_type}` : ""}{b.address ? ` · ${b.address}` : ""}</p>
                    </div>
                  </Card>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
